export default __webpack_public_path__ + "static/media/green_loc_mark.d1daa523.svg";